<template>
	<div>

		<!-- 弹幕 -->
		<van-swipe :style="{ height: '36px', position: 'absolute', bottom: isPC ? '14vh' : '12vh' }" vertical
			:show-indicators="false" :autoplay="miaoshu" :touchable="false">
			<van-swipe-item v-for="(danmus, index) in danmuList" :key="index" style="width: 100%;">
				<div class="danmu">
					<div class="danmu-box">
						<div style="width: 22px;height: 22px;"><img :src="danmus.avatar"
								style="width: 22px;height: 22px;border-radius: 50px;position: fixed;" /></div>
						<div style="padding: 0 10px;">{{ danmus.name.charAt(0) + '*'.repeat(danmus.name.length - 1) +
							danmus.name.charAt(danmus.name.length - 1) }}</div>
						<div>{{ (Math.floor(Math.random() * 60) + 1) + '秒前' }}</div>
						<div>{{ wenAn }}</div>
					</div>
				</div>
			</van-swipe-item>
		</van-swipe>

	</div>
</template>

<script>
export default {
	name: "danmuView",
	props: {
		miaoshu: {
			type: Number,
			default: 2000
		},
		wenAn: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			danmuList: [
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845065000751828992.jpg", name: "小笑玉" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059170669268992.jpg", name: "李冬丽" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059032240459776.jpg", name: "时光静好" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845057205503627264.jpg", name: "年年有余" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045951246471168.jpg", name: "一如既往" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045037685116928.jpg", name: "难得糊涂" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845044890985140224.jpg", name: "刘笑敏" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845010975356456960.jpg", name: "晨光曦影" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845002111324098560.jpg", name: "春暖花开" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845000414124150784.jpg", name: "风雨过林" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984893706178560.jpg", name: "谢长征" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984502872543232.jpg", name: "淡然接受" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844311874545487872.jpg", name: "旅途的人" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844288726492090368.jpg", name: "知足常乐" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844280029464334336.jpg", name: "谓我" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844238354637492224.png", name: "陈笑笑" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233814890614784.jpg", name: "丽笑丽" },
				{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233663568515072.jpg", name: "凌智科练" }
			], 
			//查询是否pc端缓存
			isPC: localStorage.getItem('isPC') == 'true' ? true : false
		}
	},
	created() { 
	},
	methods: { 
	}

}
</script>

<style lang="less">
.danmu {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.danmu-box {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 6px 12px;
	margin: 0 10px;
	background: #00000075;
	color: #fff;
	font-size: 26px;
	border-radius: 50px;
	// width: 60%;
}
</style>